import styled from "styled-components";

const RightPart = styled.div`
  margin-top: -100px;
  z-index: 1;
  width: 50%;
  padding-left: 1.5rem!important;


  @media (max-width: 1599px) {
    padding-right: 40px;
  }

  @media (max-width: 575px) {
    padding-left: 10px !important;
    padding-right: 10px !important;
    width:100%;
    margin-top:-40px;
  }
`;
export default RightPart;
